import styles from "./Pricing.module.css";

const PricingComponent = (props) => {
  return (
    <>
      <div className={`${styles.allItems}`}>
        <div className={`${styles.mainItems}`}>
          <div className={`${styles.header}`}>
            <div>
              <p>{props.title}</p>
              <h3>{props.titleAmount}</h3>
            </div>
            {props.icon}
          </div>
          <div className={`${styles.Content}`}>
            <p>{props.content}</p>
            <ul>
              {props.features && props.features.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>
          </div>
        </div>
        <div>
          {props.action}
        </div>
      </div>

    </>
  );
};

export default PricingComponent;
